import React, { useState, useEffect } from "react";
import { CiCheck, CiEdit, CiTrash } from "react-icons/ci"; // Example icons
import { useToast } from "../ToastContext";
import axios from "axios";
import Utils from "../../utils/utils";

const SubmissionCard = ({ props }) => {
  const { submission, setSubmissions } = props;
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();

  const [isAssessed, setIsAssessed] = useState(submission.assessed);
  const [allowResubmission, setAllowResubmission] = useState(
    submission.allowResubmission
  );
  const [answers, setAnswers] = useState(
    JSON.parse(JSON.stringify(submission.answers))
  );

  const [editMode, setEditMode] = useState(false);

  //  Marking Assessed
  const [marking, setMarking] = useState(false);
  const [submitted, setSubmitted] = useState(false); // Track submission result
  const [totalMarksObtained, setTotalMarksObtained] = useState(
    submission.totalMarksObtained && submission.totalMarksObtained >= 0
      ? submission.totalMarksObtained
      : ""
  );
  const [result, setResult] = useState(submission?.result || false);
  const [formData, setFormData] = useState({
    result: "",
    feedback: "",
    assessed: "",
  });

  const handleEditMarks = () => {
    setEditMode(!editMode); // Toggle edit mode
  };

  // Handle editing marks for each answer
  const handleMarkChange = (index, value) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index].marksObtained = value;
    setAnswers(updatedAnswers);
    // Optionally, you can send this updated value to the server to save the changes
  };

  // Handle the result fields
  const handleResultInput = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Marks asign for multiple questions
  const HandleMarksAssign = async () => {
    const confirm = window.confirm("Are you sure ? ");
    if (!confirm) return;
    try {
      const response = await axios.put(
        `${SERVER_URL}/assignments/submission/${submission._id}/mark-assign`,
        {
          answers: answers,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const res = response.data;
      const sub = res.assignment;
      sub["studentId"] = submission.studentId;
      setEditMode(false);
      setSubmissions((prev) =>
        prev.map((item) => (item._id === sub._id ? sub : item))
      );
      showToast(res.message, "success", true, 3000);
    } catch (error) {
      // console.error("Error in assessment", "e", error);
      showToast("Error in assessment", "error", true, 3000);
    }
  };

  // MArking Assessed
  const HandleSubmissionAssessed = async (e) => {
    const confirm = window.confirm("Are you sure ? ");
    if (!confirm) return;

    // if (submission.assessed) {
    //   alert("This submission is already assessed .");
    //   return;
    // }

    e.preventDefault();
    if (!formData.result || !formData.feedback) {
      alert("Please select a result and provide feedback before submitting.");
      return;
    }
    formData["totalMarksObtained"] = totalMarksObtained;

    try {
      const response = await axios.put(
        `${SERVER_URL}/assignments/submission/${submission._id}/assessed`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const res = response.data;
      res["studentId"] = submission.studentId;
      setSubmissions((prev) =>
        prev.map((item) => (item._id === res._id ? res : item))
      );
      showToast("Submission has been assessed.", "success", true, 3000);
      setSubmitted(true);
      setMarking(false);
      setIsAssessed(res.assessed);
    } catch (error) {
      //   console.error("Error marking as assessed", error);
      showToast("Error marking as assessed", "error", true, 3000);
    }
  };

  const HandleAllowResubmission = async (e) => {
    e.preventDefault();
    const confirm = window.confirm("Are you sure ? ");
    if (!confirm) return;
    try {
      const response = await axios.put(
        `${SERVER_URL}/assignments/submission/${submission._id}/allowResubmission`,
        {
          allowResubmission: !submission.allowResubmission,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const res = response.data.submission;
      res["studentId"] = submission.studentId;
      setSubmissions((prev) =>
        prev.map((item) => (item._id === res._id ? res : item))
      );
      showToast("Success", "success", true, 3000);
      setAllowResubmission(res.allowResubmission);
    } catch (error) {
      //   console.error("Error toggling resubmission", error);
      showToast("Error marking as assessed", "error", true, 3000);
    }
  };

  useEffect(() => {
    setFormData({
      result: submission.result,
      feedback: submission.feedback,
      assessed: submission.assessed,
    });
  }, [submission]);

  const ResultBtnStyle = {
    Cleared: "bg-green-100 text-green-800 hover:bg-green-200",
    "Partially Cleared": "bg-yellow-100 text-yellow-800 hover:bg-yellow-200",
    "Not Cleared": "bg-red-100 text-red-800 hover:bg-red-200",
  };

  return (
    <div
      bkl="SubmissionCard"
      className="p-4 border rounded-lg shadow-md bg-white"
      key={submission._id + submission.studentId}
    >
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="font-semibold text-lg">{submission.studentId.name}</h3>
          <p className="text-sm text-gray-500">
            Batch: {submission.studentId.batch}
          </p>
        </div>
        <div className="flex h-[100%]">
          Submitted at:{" "}
          <span className="text-amber-600 pl-1">
            {Utils.formatDateTime(submission.submittedAt)}
          </span>
        </div>
        {submission.assessed && (
          <div className="flex gap-2 items-center">
            <button disabled className="text-blue-500">
              <span>{submission.totalMarksObtained} Marks</span>
            </button>

            <div className="flex justify-center">
              {result === "Cleared" && (
                <button
                  className={`px-5 py-2 uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-green-500 ${ResultBtnStyle.Cleared}`}
                >
                  Cleared
                </button>
              )}
              {result === "Partially Cleared" && (
                <button
                  className={`px-5 py-2 uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-yellow-500 ${ResultBtnStyle["Partially Cleared"]}`}
                >
                  Partially Cleared
                </button>
              )}
              {result === "Not Cleared" && (
                <button
                  className={`px-5 py-2 uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-red-500 ${ResultBtnStyle["Not Cleared"]}`}
                >
                  Not Cleared
                </button>
              )}
            </div>

            {/* <button
            onClick={handleEditMarks}
            className={`px-4 py-2 uppercase shadow-md tracking-[0.5px] hover:shadow-lg transition-all duration-200 hover:tracking-[1px] rounded-lg ${
              editMode
                ? "text-orange-600 border border-orange-600"
                : "text-blue-600  border-blue-600 border"
            } `}
          >
            {editMode ? "Cancel Edit" : "Edit Marks"}
          </button>

          {editMode && (
            <button
              onClick={HandleMarksAssign}
              className=" text-green-700 border border-green-700 px-4 py-2 uppercase shadow-md tracking-[0.5px] 
              hover:shadow-lg transition-all duration-200 hover:tracking-[1px] rounded-lg hover:bg-green-100"
            >
              Save Marks
            </button>
          )} */}
          </div>
        )}
      </div>

      {/* Answers Section */}
      {/* <div className="space-y-4">
        {answers.map((answer, index) => (
          <div
            key={answer._id}
            className="flex justify-between items-center border-b pb-2"
          >
            <div className="flex gap-2 items-center">
              <span className="font-semibold">Question {index + 1}:</span>
              <a
                href={answer.answer || "#"}
                className={`${
                  answer.answer
                    ? "text-blue-600 underline"
                    : "cursor-not-allowed text-red-500"
                }`}
                target={answer.answer ? "_blank" : ""}
                rel={answer.answer ? "noopener noreferrer" : ""}
                onClick={(e) => {
                  if (!answer.answer) {
                    e.preventDefault();
                  }
                }}
              >
                {answer.answer || "Not Submitted"}
              </a>
            </div>

            <div className="flex gap-2 items-center">
              {editMode ? (
                <input
                  type="numeric"
                  value={answer.marksObtained}
                  onChange={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleMarkChange(index, value);
                    } else {
                      alert("Please enter numbers only.");
                      return false;
                    }
                  }}
                  className="border p-1 rounded-md w-20  border-pink-600 outline-none"
                  min={0}
                  max={100}
                />
              ) : (
                <span>{answer.marksObtained} Marks</span>
              )}
            </div>
          </div>
        ))}
      </div> */}

      {/* Save or Cancel Marks Edit */}
      {/* {editMode && (
        <div className="mt-4 flex gap-2">
          <button
            onClick={HandleMarksAssign}
            className="bg-green-600 text-white px-4 py-2 rounded-lg"
          >
            Save Marks
          </button>
          <button
            onClick={() => setEditMode(false)}
            className="bg-red-500 text-white px-4 py-2 rounded-lg"
          >
            Cancel
          </button>
        </div>
      )} */}

      <div className="flex gap-2 items-center">
        <a
          href={submission.answer || "#"}
          className={`${
            submission.answer
              ? "text-blue-600 underline"
              : "cursor-not-allowed text-red-500"
          }`}
          target={submission.answer ? "_blank" : ""}
          rel={submission.answer ? "noopener noreferrer" : ""}
          onClick={(e) => {
            if (!submission.answer) {
              e.preventDefault();
            }
          }}
        >
          {submission.answer || "Not Submitted"}
        </a>
      </div>

      {/* Resubmission Toggle */}
      <div className="mt-4 flex  items-center justify-between">
        <label className="flex items-center max-w-fit">
          <input
            type="checkbox"
            checked={allowResubmission}
            onChange={HandleAllowResubmission}
            className="checkbox border-pink-700  flex gap-2 [--chkbg:theme(colors.pink.700)] [--chkfg:white]"
          />
          <span className="ml-1">Allow Resubmission</span>
        </label>
        <div className="flex gap-2 justify-end">
          <button
            onClick={() => setMarking(!marking)}
            className={`px-4 py-2 uppercase shadow-md tracking-[0.5px] hover:shadow-lg transition-all duration-200 hover:tracking-[1px] rounded-lg ${
              marking
                ? "text-orange-600 border border-orange-600"
                : "text-blue-600  border-blue-600 border"
            } `}
          >
            {marking
              ? "Cancel"
              : submission.assessed
              ? "Re Assess"
              : "Mark Assessed"}
          </button>
          {marking && (
            <button
              onClick={HandleSubmissionAssessed}
              className={`px-6 py-2 rounded-lg  text-white uppercase ${
                formData.result && formData.feedback
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
              disabled={!formData.result || !formData.feedback}
            >
              Submit Result
            </button>
          )}
        </div>
      </div>

      {marking && (
        <form className="space-y-4 mt-4 p-6 border rounded-md shadow">
          <div className="flex gap-2">
            <div className="space-y-2 w-1/2">
              <label className="block text-sm font-medium text-gray-700">
                Select Result Status:
              </label>
              <select
                value={formData.result}
                name="result"
                onChange={handleResultInput}
                className="w-full px-3 py-2.5 text-sm border rounded-md focus:ring-pink-500 focus:border-pink-500"
              >
                <option value="" className="font-bold">
                  Select Status
                </option>
                <option value="Cleared">Cleared</option>
                <option value="Partially Cleared">Partially Cleared</option>
                <option value="Not Cleared">Not Cleared</option>
              </select>
            </div>

            <div className="space-y-2  w-1/2">
              <label className="block text-sm font-medium text-gray-700">
                Marks Obtained:
              </label>
              <input
                type="tel"
                placeholder="Marks Obtained"
                value={totalMarksObtained}
                pattern="[0-9]*"
                inputMode="numeric"
                name="setTotalMarksObtained"
                onChange={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setTotalMarksObtained(value);
                  } else {
                    alert("Please enter numbers only.");
                    return false;
                  }
                }}
                className=" max-w-[120px] px-3 py-2 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </div>
          </div>
          {/* Feedback Box */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Provide Feedback:
            </label>
            <textarea
              value={formData.feedback}
              name="feedback"
              onChange={handleResultInput}
              placeholder="Write your feedback here..."
              rows={2}
              className="w-full px-4 py-3 text-sm border rounded-md focus:ring-pink-500 focus:border-pink-500 focus:outline-none"
            />
          </div>

          {/* Feedback Message */}
          {submitted && (
            <div className="text-green-600 font-medium mt-4">
              Result has been submitted successfully!
            </div>
          )}
        </form>
      )}
    </div>
  );
};

export default SubmissionCard;
